var DESCRIPTORS = require('../internals/descriptors');

var objectDefinePropertyModule = require('../internals/object-define-property');

var regExpFlags = require('../internals/regexp-flags'); // `RegExp.prototype.flags` getter
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags


if (DESCRIPTORS && /./g.flags != 'g') {
  objectDefinePropertyModule.f(RegExp.prototype, 'flags', {
    configurable: true,
    get: regExpFlags
  });
}